import { useQueryParam } from '@mi-front/core';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * After a successful OAuth / connect redirect to the manage page
 * (`connectResult=success` + `connectionId`), send the user to that
 * connection's settings page so they can configure defaults immediately.
 */
export function useRedirectToConnectionSettingsOnSuccess(platformId: string) {
  const history = useHistory();
  const connectResult = useQueryParam('connectResult');
  const connectionId = useQueryParam('connectionId');

  useEffect(() => {
    if (connectResult !== 'success' || !connectionId) {
      return;
    }

    history.replace(
      `/admin/social-export/${platformId.toLowerCase()}/settings/${connectionId}?connectResult=success`,
    );
  }, [connectResult, connectionId, platformId, history]);
}
